import JiraIcon from '@motional/inguitiv/svg/logo/jira.svg?react';

function Icon() {
  return <JiraIcon />;
}

export default Icon;
